import React, {useState, useEffect, useRef, useReducer} from 'react';
import {BrowserRouter as Router, Routes, Route, Link} from 'react-router-dom';
import './App.css';
import SignIn from './pages/SignIn';
import Register from './pages/Register';
import Home from './pages/Home';
import UserProfile from './pages/UserProfile';


const App = () => {

    return (
        <Router>
            <Routes>
                <Route path='/' element={< Home/>}></Route>
                <Route path='/login' element={< SignIn/>}></Route>
                <Route path='/register' element={< Register/>}></Route>
                <Route path='/profile' element={< UserProfile/>}></Route>
            </Routes>
        </Router>
    );
}

export default App;
